import api from 'lib/api';

export const TEXT_TO_IMAGE = 'TEXT_TO_IMAGE';
export const CONTENT_FROM_PLANDATA = 'CONTENT_FROM_PLANDATA';

export function text_to_image(values, callback) {
	return {
		type: TEXT_TO_IMAGE,
		payload: new Promise(resolve => {
			api.post('ai/imagefromtext', values).then((response) => {
				resolve({ ...values, image_url: response.data });

				if (callback != null) {
					callback(response.data);
				}
			});
		}),
	}
}
export function content_from_plandata(values, callback) {
	return {
		type: CONTENT_FROM_PLANDATA,
		payload: new Promise(resolve => {
			api.post('ai/contentfromPlanData', values).then((response) => {
				resolve({ ...values, plan_content: response.data });

				if (callback != null) {
					callback(response.data);
				}
			});
		}),
	}
}
